import { AccessToken } from '../../types';

/**
 * Reads the `sub` (subject / user id) claim from a JWT WITHOUT verifying it.
 * Signature verification is the backend's job; the client only needs the
 * identity to confirm that a returned-to session belongs to the same user (the
 * shared-computer guard on the exited screen). Returns undefined for a malformed
 * or partial token. Note: does not check expiry, so it still reads the id from
 * an expired token.
 */
export const decodeJwtSub = (token: AccessToken): string | undefined => {
  try {
    const payload = token.split('.')[1];
    if (!payload) return undefined;

    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join(''),
    );

    const { sub } = JSON.parse(json) as { sub?: string | number };
    return sub === undefined ? undefined : String(sub);
  } catch {
    return undefined;
  }
};
